import { render } from "./FormInputText.vue?vue&type=template&id=13c8fc48"
import script from "./FormInputText.vue?vue&type=script&lang=js"
export * from "./FormInputText.vue?vue&type=script&lang=js"

import "./FormInputText.vue?vue&type=style&index=0&id=13c8fc48&lang=css"

import exportComponent from "/Users/giacomo/Developer/tandu/barbera/barberabilance-docs-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__